<template>
  <div class="leftMenuWrapper" :class="{'siderbar-show': !sideBarShow}">
    <!--顶部返回按钮，放在此处，是因为方便根据导航切换控制显隐-->
    <BackBtn v-append-to-body v-show="showBackBtn"></BackBtn>
    <!--导航栏-->
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        ref="navMenu"
        mode="vertical"
        class="navMenu"
        :default-active.sync="activeIndex"
        :unique-opened="true"
        :collapse="false"
      >
        <Menu :navMenus="navMenus.menus" :iconShow='true'></Menu>
      </el-menu>

    </el-scrollbar>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  // import Bus from '../eventBus.js'
  // import AdminApi from '../../api/eos/admin'
  import SystemManage from '../../../../api/TMS/SystemManage'
  import ApiCourseNormal from '../../../../api/TMS/CourseNormal'
  // import DoUrl from '../../utils/DoUrl'
  import BackBtn from './BackBtn'
  import Menu from './Menu'
  import ToMenuTree from './ToMenuTree.js'
  export default {
    components: {
      Menu,
      BackBtn,
    },
    data() {
      return {
        navMenus: {},
        activeIndex: '',
        initActive: false,
        initActiveNav: '',
        initActiveIndex: '',
        showBackBtn: false,
        isBtnEnd: false,
      }
    },
    props: {
      sideBarShow: { default: true },
    },
    computed: mapState({
      cIsTms: function() {
        return window.location.href.indexOf('sysCode=club') != -1 ? 'club' : 'portal'
      },
      pageUrlHash: function() {
        return window.location.hash && window.location.hash.split('#')[1].split('?')[0]
      },
    }),
    async mounted() {
      // await this.getMenus()
      await this.getMenusPortal()
      this.initBackBtn()
    },
    methods: {
      // async getMenus() {
      //   let params = {
      //     id: DoUrl.getSearchByName('id') || 2234,
      //     mock: true,
      //   }
      //   let navMenus = await AdminApi.getSysMenu(params)
      //   // 成长课程 目录动态导入
      //   this.navMenus = await this.addCourseMenu(navMenus)
      //   this.navMenus.menus = this.addId(this.navMenus.menus, '')
      //   if (this.activeIndex === '') {
      //     this.activeIndex = sessionStorage.activeIndex
      //   }
      // },
      async getMenusPortal() {
        let reqData = {
          code: this.cIsTms
        }
        let aNavMenus = await SystemManage.getUserAccess(reqData)
        this.$store.commit('aNavMenus', aNavMenus)
        await ToMenuTree.formate(aNavMenus)
        let navMenus = {}
        navMenus.menus = ToMenuTree.returnData()
        // 成长课程 目录动态导入
        this.navMenus = await this.addCourseMenu(navMenus)
        this.navMenus.menus = this.addId(this.navMenus.menus, '')
        if (this.activeIndex === '') {
          this.activeIndex = sessionStorage.activeIndex
        }
      },
      // 成长课程 目录动态导入
      async addCourseMenu(navMenus) {
        let resData = []
        try {
          resData = await ApiCourseNormal.listReportDataAppGroup({})
        } catch (e) {
          resData = []
        }
        let courseMenu = []
        // 栏目 应用两级
        resData.forEach((course, courseIndex) => {
          courseMenu.push({
            icon: '',
            name: course.title,
            url: '',
            childs: []
          })
          course.detailList.forEach((app) => {
            let url = ''
            // 0 是数据应用，1是普通链接
            if (app.type == 1) {
              const seperate = app.code.indexOf('?') > -1 ? '&' : '?'
              url = decodeURIComponent(app.code) + seperate + 'hideTMSBack=true'
            } else {
              // hideTMSBack 导航菜单强制隐藏返回
              url = '/admin/index.html#/TMS/course-router?hideTMSBack=true&dataAppId=' + app.code
            }
            courseMenu[courseIndex].childs.push({
              icon: '',
              name: app.title,
              url: url,
              childs: []
            })
          })
        })
        // 在原目录中找到成长课程 ,以tms_growCourse为标识
        //
        navMenus.menus.forEach((nav) => {
          if (nav.icon == 'tms_growCourse') {
            let findSetting = false
            // 有成长课程设置，在childs成长课程设置后添加 tms_growCourse_settinig
            nav.childs.forEach((child, childIndex) => {
              if (child.icon == 'tms_growCourse_settinig') {
                findSetting = true
                nav.childs.splice(childIndex + 1, 0, ...courseMenu)
              }
            })
            // 无在倒数第二个添加
            if (!findSetting) {
              nav.childs.splice(nav.childs.length - 1, 0, ...courseMenu)
            }
          }
        })
        return navMenus
      },
      addId(_menus, _baseId) {
        if (!_menus.length) { return }
        for (const key in _menus) {
          if (_menus.hasOwnProperty(key)) {
            const element = _menus[key]
            element.id = _baseId === '' ? key : _baseId + '-' + key
            if (element.url && this.pageUrlHash === element.url.split('#')[1] && !this.activeIndex.length) {
              this.activeIndex = element.id
            }
            if (element && element.childs && element.childs.length) {
              element.childs = this.addId(element.childs, element.id)
            }
          }
        }
        return _menus
      },
      getNowSideId(_menus) {
        if (!(_menus && _menus.length)) { return }
        for (const key in _menus) {
          if (_menus.hasOwnProperty(key)) {
            const element = _menus[key]
            // 兼容微应用加载
            let fullPath = this.$route.fullPath
            // TODO 判断fullPath 与当前 url, 截取#号后面的vue路由部分， 从中找到相应的导航节点
            if (fullPath.includes('#')) fullPath = fullPath.split('#')[1]
            let elementUrl = element.url.split('#')[1] && element.url.split('#')[1]
            // TMS/course-router比较特殊，是动态导航，需要判断全路径
            // 素养admin的动态路径 需要判断全路径
            if (/course-router/.test(fullPath) && /admin/.test(location.href)) {
              if (fullPath.includes(elementUrl)) {
                this.initActiveIndex = element.id
                break
              }
              break
            }
            // 截掉？后面参数
            if (fullPath.includes('?')) fullPath = fullPath.split('?')[0]
            if (elementUrl && elementUrl.includes('?')) elementUrl = elementUrl.split('?')[0]
            if (fullPath == elementUrl) {
              this.initActiveIndex = element.id
              break
            } else {
              if (element && element.childs && element.childs.length) {
                this.getNowSideId(element.childs)
              }
            }
          }
        }
      },
      // 左侧目录导航的链接不显示返回按钮
      initBackBtn() {
        this.isBtnEnd = true
        // url有隐藏返回标识强制不显示，空路由也不显示
        if (/hideTMSBack=true/.test(location.href) || /empty-router/.test(location.href)) {
          this.showBackBtn = false
          return
        }
        // 根据当前url与导航url是否一致判断显示返回
        this.getNowSideId(this.navMenus.menus)
        if (this.initActiveIndex === '') {
          this.showBackBtn = true
        } else {
          this.showBackBtn = false
        }
        this.initIndex()
      },
      initIndex() {
        if (this.initActiveIndex === '' && sessionStorage.activeIndex) {
          this.initActiveIndex = sessionStorage.activeIndex
        }
        let aInitActiveIndex = this.initActiveIndex.split('-')
        aInitActiveIndex.pop()
        this.initActiveNav = aInitActiveIndex.join('-')
        if (this.initActiveNav.length) {
          try {
            this.$refs.navMenu.open(this.initActiveNav)
          } catch (error) {
            console.log(error)
          }
        }
        this.activeIndex = this.initActiveIndex
      }
    },
    watch: {
      // 监听路由变化，对应激活左侧导航
      '$route'(newValue, oldValue) {
        // TODO 来自同一个路由的目录，先不初始化目录
        if (newValue.fullPath.split('?')[0] == oldValue.fullPath.split('?')[0]) {
          return
        }
        if (newValue.fullPath != oldValue.fullPath) {
          this.initActiveNav = ''
          this.initActiveIndex = ''
          // 返回按钮及导航索引处理
          if (this.isBtnEnd) {
            this.initBackBtn()
          }
        }
      }
    },
  }
</script>

<style lang="less">
  @import "./less/sidebar.less";
</style>
